// Não sei a logica, usei chatGPT

function levenshteinDistanceFlexible(str1: string, str2: string): number {
    const words1 = str1.split(' ')
    const words2 = str2.split(' ')

    let totalDistance = 0

    // Rastrear palavras já usadas em `words2`
    const words2Used = new Array(words2.length).fill(false)

    // Para cada palavra de `str1`, encontrar a melhor correspondência em `words2`
    for (const word1 of words1) {
        let minDistance = Infinity
        let bestMatchIndex = -1

        // Tenta encontrar a melhor correspondência em `str2`
        for (let i = 0; i < words2.length; i++) {
            if (!words2Used[i]) {
                const distance = levenshteinWordDistance(word1, words2[i])
                if (distance < minDistance) {
                    minDistance = distance
                    bestMatchIndex = i
                }
            }
        }

        // Se encontrou correspondência, marca como usada
        if (bestMatchIndex !== -1) {
            words2Used[bestMatchIndex] = true
        }

        // Somar a menor distância encontrada
        totalDistance += minDistance === Infinity ? 0 : minDistance
    }

    // Penalizar palavras extras restantes em `words2` que não foram usadas
    for (let i = 0; i < words2.length; i++) {
        if (!words2Used[i]) {
            totalDistance += words2[i].length * 0.3 // Penalidade moderada
        }
    }

    return totalDistance
}

// Função para calcular a distância de Levenshtein entre duas palavras
function levenshteinWordDistance(word1: string, word2: string): number {
    const len1 = word1.length
    const len2 = word2.length

    const dp: number[][] = Array.from({ length: len1 + 1 }, () => Array(len2 + 1).fill(0))

    for (let i = 0; i <= len1; i++) dp[i][0] = i
    for (let j = 0; j <= len2; j++) dp[0][j] = j

    for (let i = 1; i <= len1; i++) {
        for (let j = 1; j <= len2; j++) {
            if (word1[i - 1] === word2[j - 1]) {
                dp[i][j] = dp[i - 1][j - 1]
            } else {
                dp[i][j] = Math.min(
                    dp[i - 1][j] + 1,
                    dp[i][j - 1] + 1,
                    dp[i - 1][j - 1] + 1,
                )
            }
        }
    }

    return dp[len1][len2]
}

export { levenshteinDistanceFlexible }
